/**
 * Help Mode Toggle Component
 * 
 * Toggle button for enabling/disabling Help Mode.
 * Shows visual feedback when Help Mode is active.
 */

import React from 'react';
import { useHelpMode } from './HelpModeProvider';

export const HelpModeToggle = ({ className = "", ...props }) => {
  const { isHelpMode, toggleHelpMode } = useHelpMode();

  return (
    <button
      onClick={toggleHelpMode}
      className={`group p-2 rounded-lg transition-all duration-200 border ${
        isHelpMode
          ? 'bg-yellow-400/25 border-yellow-300/60'
          : 'hover:bg-yellow-400/25 border-gray-600/30 hover:border-yellow-300/60'
      } ${className}`}
      title={isHelpMode ? "Exit help mode" : "Enter help mode"}
      {...props}
    >
      <svg className={`w-4 h-4 transition-colors ${
        isHelpMode
          ? 'text-yellow-200'
          : 'text-gray-300 group-hover:text-yellow-200'
      }`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    </button>
  );
};

